import { Box, Checkbox, FormControlLabel, Stack } from "@mui/material";
import { PaperMaterialInventoriesPermission } from "commons/enum/permission";
import { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DateRange } from "share-components/atomics/date-range";
import {
  AddButton,
  ExportExcelButton,
} from "share-components/mui-wrap/button/action-button";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { AddPaperGoodsReceipt } from "../add-goods-receipt/add-goods-receipt";
import { PaperMaterialGroupSelectionConnected } from "../share";
import { UpdatePaperGoodsReceipt } from "../update-goods-receipt/update-goods-receipt";
import { ExportExcel } from "./export-excel/export-excel";
import { PaperGoodsReceiptTable } from "./paper-goods-reciept-table";

export const PaperGoodsReceiptList = observer(() => {
  const {
    paperInventoryManagement: {
      paperGoodsReceiptStore: {
        setProp,
        pagination,
        getPaperGoodsReceipt,
        openNew,
        openEdit,
        openExportExcel,
        queryParams: {
          dateRangeFilter: {
            fromAsDayJs,
            toAsDayJs,
            setProp: setDateRangeProps,
          },
          gsm,
          type,
          code,
          brand,
          rollNumber,
          specificationSize,
          setProp: setQueryParamProps,
          showZeroQuantity,
        },
      },
    },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    getPaperGoodsReceipt();
  }, [getPaperGoodsReceipt, pagination]);

  const fromDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("from", value ? value.toString() : null);
    },
    [setDateRangeProps],
  );

  const toDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("to", value ? value.toString() : null);
    },
    [setDateRangeProps],
  );

  const showZeroQuantityHandler = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setQueryParamProps("showZeroQuantity", checked);
      await getPaperGoodsReceipt();
    },
    [getPaperGoodsReceipt, setQueryParamProps],
  );

  return (
    <>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        padding={"10px 0"}
      >
        <PageFilterContainer>
          <DateRange
            label={"Ngày nhập"}
            fromDate={fromAsDayJs}
            toDate={toAsDayJs}
            onFromDateChanged={fromDateChangedHandler}
            onToDateChanged={toDateChangedHandler}
          ></DateRange>

          <PaperMaterialGroupSelectionConnected
            codeSelected={code}
            specificationSizeSelected={specificationSize}
            brandSelected={brand}
            rollNumberSelected={rollNumber}
            typeSelected={type}
            gsmSelected={gsm}
            setSelectionProp={setQueryParamProps}
          />

          <SearchButton asyncAction={onSearch}></SearchButton>
        </PageFilterContainer>
      </Stack>
      <Stack direction={"row"} justifyContent={"right"} spacing={1}>
        <Box>
          <ExportExcelButton
            accessPermission={[
              PaperMaterialInventoriesPermission.ExportExcelByRollNumber,
            ]}
            onClick={() => {
              setProp("openExportExcel", true);
            }}
          ></ExportExcelButton>
        </Box>

        <Box>
          <AddButton
            accessPermission={[
              PaperMaterialInventoriesPermission.ReceiptCreate,
            ]}
            onClick={() => {
              setProp("openNew", true);
            }}
          >
            Thêm nhập kho
          </AddButton>
        </Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={showZeroQuantity}
              onChange={showZeroQuantityHandler}
            />
          }
          label="Gồm tồn bằng 0"
        />
      </Stack>
      <PageContentContainer sx={{ marginTop: "10px" }}>
        <PaperGoodsReceiptTable></PaperGoodsReceiptTable>
      </PageContentContainer>

      <>
        {openNew && <AddPaperGoodsReceipt></AddPaperGoodsReceipt>}
        {openEdit && <UpdatePaperGoodsReceipt></UpdatePaperGoodsReceipt>}
        {openExportExcel && <ExportExcel></ExportExcel>}
      </>
    </>
  );
});
